//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@/0/components/comForm/comPageHeader";
import FormEdit from "@/0/components/comForm/comFormEdit2X";
import DialogOperateList from "@/0/components/comForm/comOperateList/comDialogOperateList";

export default {
  props: [],
  components: {
    "page-header": PageHeader,
    "form-edit": FormEdit,
    "dialog-operate-list": DialogOperateList,
  },
  data() {
    return {
      openId:'',
      parentFormData : null,
      formItem: null,


      isShow: false,
      headerConfig: {
        Title: "高级查询"
      },
      formConfig: {},
      formViewDataList: [],

      operateListConfig: {
        ButtonList: []
      },      
    };
  },
  created() {

  },

  methods: {

    IsShow() {
      this.isShow = !this.isShow;
    },

    Show(){
      this.isShow = true;
    },

    Hide(){
      this.isShow = false;
    },

    
    $hide(){
      this.isShow = false;
    },

    $getParentForm(){
      return this.$parent.$getThisForm();
    },

    $getSubmitData(){

      var formData = this.$refs.comFormEdit.$getSubmitData();
        if(!formData){
          formData = {};
        }
      return formData;
    },    


    async initForm(url,parentData) {
      //this.openId = openId;
      this.parentFormData = parentData;

      this.isFormInit = false;
      this.$msg.showLoading("正在核验...");
      // var postData = {
      //     OpenId: openId,
      // }

      var postData = parentData;

      let { data: result } = await this.$http({
          url: url,
          method: "post",
          data: postData,
      });

      this.$msg.hideLoading();
      if (result.state == 1) {
        this.isFormInit = true;
        this.$msg.succ("核验通过");

        var resultData = result.data;
        this.formItem = resultData;
        this.headerConfig.Title = resultData.Title;
        this.formViewDataList = resultData.GroupViewList;

        setTimeout(() => {
          console.log("this.$refs.comDialogOperateList",this.$refs.comDialogOperateList);
          if(this.$refs.comDialogOperateList){
            this.$refs.comDialogOperateList.setData(resultData.OperateList);
          }
        },0);
        return;
      }
      this.$msg.alert(result.msg);
    },
    
  }
};
